import React, { useContext } from 'react';
import WindowWrapper from '../context/WindowWrapper';
import Logo from '../../assets/img/logo_other_way_around.png';
import CheckField from '../forms/CheckField';
import PrimaryButton from '../buttons/PrimaryButton';
import DomainData from '../../assets/datasets/DomainData';
import { TrackingContext } from '../context/Tracking';

const CookieWindow = ({ style, close, className, ...props }) => {
  const [acceptedCookiesState, setAcceptedCookiesState] = React.useState(DomainData.cookies.reduce((a, v) => ({ ...a, [v.id]: true }), {}));
  const { setAcceptedCookies } = useContext(TrackingContext);

  return (
    <WindowWrapper
      maxWidth={600}
      maxHeight={600}
      className={'window-wrapper nice-scroll ' + (className || '')}
      style={style}
      close={close}
    >
      <center>
        <img src={Logo} width={80} />
        <br />
        <h3>Deine Cookie-Einstellungen</h3>
        <br />
        <p>Hier kannst du die Cookies abwählen, die nicht abgespeichert werden sollen.</p>
      </center>
      <table>
        <tbody>
          {
            DomainData.cookies.map(cookie => {
              return (
                <React.Fragment key={cookie.id}>
                  <tr>
                    <td style={{ paddingTop: 30 }}>
                      <b>{cookie.name}</b>
                    </td>
                    <td style={{ paddingTop: 30 }}>
                      <CheckField
                        value={acceptedCookiesState[cookie.id]}
                        setValue={v => setAcceptedCookiesState(old => ({ ...old, [cookie.id]: v }))}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td style={{ color: 'grey' }}>
                      <i>{cookie.description}</i>
                    </td>
                    <td>
                      &nbsp;
                    </td>
                  </tr>
                </React.Fragment>
              );
            })
          }
        </tbody>
      </table>
      <br />
      <PrimaryButton
        onClick={() => { setAcceptedCookies(Object.keys(acceptedCookiesState).filter(ac => acceptedCookiesState[ac])); close(); }}
      >
        Speichern
      </PrimaryButton>
    </WindowWrapper>
  );
}
;
export default CookieWindow;
